import { Box, Button, Typography } from '@mui/material';
import { IconSvg } from '../Icon';
import { PdpProgressReportDTO } from '@/types/models';
import timeFormat from '@/utils/timeFormat';
interface HexagonProps {
  number: number;
}
const Hexagon = ({
  number
}: HexagonProps) => {
  return <Box sx={{
    position: 'relative'
  }} data-sentry-element="Box" data-sentry-component="Hexagon" data-sentry-source-file="ReportItem.tsx">
      <Box data-sentry-element="Box" data-sentry-source-file="ReportItem.tsx">
        <IconSvg component='CardNumbers' width={30} height={30} data-sentry-element="IconSvg" data-sentry-source-file="ReportItem.tsx" />
      </Box>
      <Typography sx={{
      position: 'absolute',
      top: '7px',
      left: '10px',
      color: 'white'
    }} variant='bodyStrong__Wallfund' data-sentry-element="Typography" data-sentry-source-file="ReportItem.tsx">
        {number}
      </Typography>
    </Box>;
};
interface ReportItemProps {
  data: PdpProgressReportDTO;
  index: number;
}
const ReportItem = ({
  data,
  index
}: ReportItemProps) => {
  const {
    title,
    brief,
    createdAt,
    file,
    status
  } = data;
  const texts = {
    downloadTitle: 'دانلود گزارش'
  };
  return <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: 'var(--corner_radius_m)',
    border: '1px solid',
    borderColor: 'stroke.stroke2',
    p: 'var(--spacing_m)',
    gap: 'var(--spacing_xs)'
  }} data-sentry-element="Box" data-sentry-component="ReportItem" data-sentry-source-file="ReportItem.tsx">
      <Box sx={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%'
    }} data-sentry-element="Box" data-sentry-source-file="ReportItem.tsx">
        <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 'var(--spacing_xs)'
      }} data-sentry-element="Box" data-sentry-source-file="ReportItem.tsx">
          <Hexagon number={index + 1} data-sentry-element="Hexagon" data-sentry-source-file="ReportItem.tsx" />
          <Typography variant='bodyStrong__Wallfund' data-sentry-element="Typography" data-sentry-source-file="ReportItem.tsx">{title}</Typography>
        </Box>
        <Typography variant='captionSmallMedium__Wallfund' sx={{
        bgcolor: status === 'passed' ? 'critical.bg' : 'unset',
        color: status === 'passed' ? 'white' : 'text.text',
        borderRadius: status === 'passed' ? 'var(--corner_radius_circular)' : 0,
        px: 'var(--spacing_xxs)'
      }} data-sentry-element="Typography" data-sentry-source-file="ReportItem.tsx">
          {createdAt && timeFormat(new Date(createdAt))}
        </Typography>
      </Box>
      <Box className='truncate-text' data-sentry-element="Box" data-sentry-source-file="ReportItem.tsx">
        <Typography variant='captionRegular__Wallfund' color={'text.text2'} data-sentry-element="Typography" data-sentry-source-file="ReportItem.tsx">
          {brief}
        </Typography>
      </Box>
      <Button variant='outlined' color='primary' href={file.url} target='_blank' startIcon={<IconSvg component='Download' width='20' height='20' />} data-sentry-element="Button" data-sentry-source-file="ReportItem.tsx">
        {texts.downloadTitle}{' '}
      </Button>
    </Box>;
};
export default ReportItem;